import React from "react";
import LandingPage from "./Survey/LandingPage";

function App() {
  return <LandingPage />;
}

export default App;